// Firebase 데이터베이스에서 실시간 사용자 수를 관리하는 클래스
import { database } from './firebase-config.js';
import { ref, onValue, get } from 'firebase/database';

class UserCounter {
  constructor() {
    this.usersRef = ref(database, 'users');
    this.userCountElement = document.getElementById('userCount');
    this.unsubscribe = null;
  }

  // 사용자 수 업데이트 시작
  start() {
    // 이미 구독 중인 경우 중복 방지
    if (this.unsubscribe) return;
    
    // 사용자 수 변경 감지 리스너 설정
    this.listenToUserCount();
  }

  // 사용자 수 변경 감지 및 UI 업데이트
  listenToUserCount() {
    // 기존 구독 취소
    if (this.unsubscribe) {
      this.unsubscribe();
    }
    
    // 새로운 구독 설정: users 노드 변경 감지
    this.unsubscribe = onValue(this.usersRef, (snapshot) => {
      if (snapshot.exists()) {
        // users 노드의 자식 수 = 사용자 수
        const count = Object.keys(snapshot.val()).length;
        this.updateUserCountDisplay(count);
      } else {
        // 데이터가 없는 경우 0으로 표시
        this.updateUserCountDisplay(0);
      }
    });
  }

  // UI의 사용자 수 표시 업데이트
  updateUserCountDisplay(count) {
    if (this.userCountElement) {
      this.userCountElement.textContent = `(${count})`;
    } else {
      // DOM이 로드되지 않았을 경우, 나중에 다시 시도
      setTimeout(() => {
        this.userCountElement = document.getElementById('userCount');
        if (this.userCountElement) {
          this.userCountElement.textContent = `(${count})`;
        }
      }, 1000);
    }
  }

  // 리소스 정리
  cleanup() {
    // 구독 해제
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
    }
  }
}

export const userCounter = new UserCounter();
export default userCounter; 